export const LOGIN_ROUTE = '/oauth/login';
export const LOGOUT_ROUTE = '/oauth/logout';
export const INDEX_ROUTE = '/';
export const PROFESSION_ROUTE = '/profession/:id';
export const PROFESSIONS_ROUTE = '/professions';
export const ED_PROGRAMS_ROUTE = '/courses';
export const COLLECTION_ED_PROGRAM_ROUTE = '/collection/edprogram/:slug';
export const CERT_LANDING = '/assessment';
export const CERT_START_TEST_CODE = `${CERT_LANDING}/start_test_code`;
export const LK_ROUTE = '/lk';
export const PROFILE_ROUTE = '/profile';
export const ARTICLES_CATALOG_ROUTE = '/articles';
export const ARTICLE_ROUTE = '/article/:slug';
export const ADMIN_COURSES_CATALOG_ROUTE = '/admin/courses';
export const ADMIN_COURSE_CREATE_ROUTE = '/admin/courses/create';
export const ADMIN_COURSE_EDIT_ROUTE = '/admin/courses/:id/edit';
export const ADMIN_EDUCATION_CATALOG_ROUTE = '/admin/educations';
export const ADMIN_STREAMS_CATALOG_ROUTE = '/admin/streams';
export const ADMIN_STREAM_EDIT_ROUTE = '/admin/streams/:id/edit';
export const ADMIN_STREAM_CREATE_ROUTE = '/admin/streams/create';
export const ADMIN_EDUCATION_CREATE_ROUTE = '/admin/education/create';
export const ADMIN_EDUCATION_EDIT_ROUTE = '/admin/education/:id/edit';
export const ADMIN_PROFESSIONS_CATALOG_ROUTE = '/admin/professions';
export const ADMIN_PROFESSION_CREATE_ROUTE = '/admin/professions/create';
export const ADMIN_PROFESSION_EDIT_ROUTE = '/admin/professions/:id/edit';
export const ADMIN_PROVIDERS_CATALOG_ROUTE = '/admin/providers';
export const ADMIN_PROMOTIONS_CATALOG_ROUTE = '/admin/promotions';
export const ADMIN_STOREFRONTS_ROUTE = '/admin/storefronts';
export const ADMIN_ARTICLES_CATALOG_ROUTE = '/admin/articles';
export const ADMIN_ARTICLE_CREATE_ROUTE = '/admin/articles/create';
export const ADMIN_ARTICLE_EDIT_ROUTE = '/admin/articles/:id/edit';
export const ADMIN_COLLECTION_ED_PROGRAMS_CATALOG_ROUTE = '/admin/collection-education-program';
export const ADMIN_PROVIDERS_STREAM_WEIGHT = '/admin/providers-stream-weight';
